import { defineMessages } from 'react-intl-next';

export default defineMessages({
	instructionsLabel: {
		id: 'rovo-chat.view-agent.instructions-label',
		defaultMessage: 'Instructions',
		description: 'Label for instructions',
	},
	copyInstructionsLabel: {
		id: 'rovo-chat.view-agent.copy-instructions-label',
		defaultMessage: 'Copy',
		description: 'Label for copy instructions button',
	},
	copyInstructionsTooltip: {
		id: 'rovo-chat.view-agent.copy-instructions-tooltip',
		defaultMessage: 'Copy instructions',
		description: 'Label for copy instructions tooltip',
	},
	noInstructionPlaceholder: {
		id: 'rovo-chat.view-agent.no-instruction-placeholder',
		defaultMessage: 'This Agent has no custom instructions',
		description: 'Placeholder for no instructions',
	},
	privateInstructionsTitle: {
		id: 'rovo-chat.view-agent.hidden-instructions-title',
		defaultMessage: 'These instructions are private',
		description:
			'Title of the instructions section, this is displayed when instructions are purposely hidden',
	},
	privateInstructionsDescription: {
		id: 'rovo-chat.view-agent.hidden-instructions-description',
		defaultMessage: 'Forge Agents built with code have their instructions hidden for privacy.',
		description:
			'Description of the instructions section, this is displayed when instructions are purposely hidden',
	},
});
